export default {
  data() {
    return {
      items: [],
    };
  },
  methods: {
    toggleInvoiceDetails(invoice) {
      !invoice.isOpen
        ? this.expandInvoiceDetails(invoice)
        : this.hideInvoiceDetails(invoice);
    },
    expandInvoiceDetails(invoice) {
      invoice.DETFAC.forEach((item, index) => {
        item.inserted = true;
        item.invoiceId = invoice.BELNR;
        this.items.splice(
          this.getInvoiceIndex(invoice.BELNR) + index + 1,
          0,
          item
        );
      });
      this.setInvoiceOpenState(true, invoice.BELNR);
    },
    hideInvoiceDetails(invoice) {
      this.items = this.items.filter(
        (item) => item.invoiceId !== invoice.BELNR
      );
      this.setInvoiceOpenState(false, invoice.BELNR);
    },
    setInvoiceOpenState(isOpen, id) {
      const position = this.getInvoiceIndex(id);
      this.$set(this.items[position], 'isOpen', isOpen);
    },
    getInvoiceIndex(id) {
      return this.items.findIndex((item) => item.BELNR === id);
    },
    reorderNotApplied(invoices) {
      return invoices.slice().sort((a, b) => {
        return (a.TIPO === 'FACTURA') - (b.TIPO === 'FACTURA');
      });
    },
    reorderExpired(invoices) {
      return invoices.slice().sort((a, b) => {
        return (a.ESTAT !== 'VENCIDO') - (b.ESTAT !== 'VENCIDO');
      });
    },
    reorderItemsData(invoices) {
      return this.reorderExpired(this.reorderNotApplied(invoices));
    },
  },
};
